export default {
  business: 'Pour votre activité',
  'get-inspired': "Trouvez l'inspiration",
  'how-to': 'Tutoriels',
  news: 'Les nouveautés',
  printstories: 'Printstories',
  highlights: 'Highlights',
  'business-growth': 'Business growth',
}
